import { Module } from 'vuex';
import RootState from '@/types/store/RootState';

import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import StepsState from '@/types/store/StepsState';

const module: Module<StepsState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default module;
